<header class="hc-header">
  <a class="hc-brand" routerLink="/">
    <img src="/assets/images/logo.png" alt="EasyEviction" class="hc-logo" />
    <span class="hc-brand-text">Help</span>
  </a>

  @if (!isHome) {
    <form class="hc-search" (ngSubmit)="onSearch()">
      <input
        type="search"
        name="q"
        placeholder="Search help articles…"
        aria-label="Search help articles"
        [(ngModel)]="searchQuery"
      />
      <button mat-icon-button type="submit" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </form>
  }

  @if (authEnabled) {
    <div class="hc-auth">
      <button mat-flat-button color="primary" (click)="signIn()">Sign in</button>
    </div>
  }
</header>

<main class="hc-main">
  <router-outlet></router-outlet>
</main>

<footer class="hc-footer">
  <span>© {{ year }} EasyEviction</span>
  <span class="hc-footer-sep">·</span>
  <a [href]="termsOfServiceUrl" target="_blank" rel="noopener noreferrer">Terms of Service</a>
  <span class="hc-footer-sep">·</span>
  <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
</footer>
